//Import Services
import Services from '../core/services'

export default {

  getContracts( maxPage ) {
    const promiseList = [];
    for(let page = 2;page < maxPage;page++){
      promiseList.push(
        new Promise((resolve) => {
          return Services
            .get(`api/contracts/contract/paging/${page}`)
            .then( ({data}) => { 
              if (data && data.success) {
                return resolve(data);  
              }
              return resolve(null);
            })
            .catch(() => {
              return resolve(null);
            }); 
        })
      );
    }
    return Promise.all(promiseList).then((responses) => {
      const data = {contracts: []};
      responses.forEach((response) => {
        data.contracts = data.contracts.concat(response.contracts);
      });
      return data;
    });
  },
  getContractItems( contractId ) {
    return new Promise((resolve) => {
      return Services
        .get(`api/contracts/contract/${contractId}/items`)
        .then( ({data}) => {      
          if (data && data.success && Array.isArray(data.items)) {
            return resolve(data.items);  
          }
          return resolve([]);
        })
        .catch(() => {
          return resolve([]);
        }); 
    })
  },
  getContractItemDetails( contractId, itemId ) {
    return new Promise((resolve) => {
      return Services
        .get(`api/contracts/contract/${contractId}/items/${itemId}/details`)
        .then( ({data}) => {      
          if (data && data.success && Array.isArray(data.details)) {
            return resolve(data.details);  
          }
          return resolve([]);
        })
        .catch(() => {
          return resolve([]);
        }); 
    })
  },
  getContractItemDetailFees( contractId, detailId ) {
    return new Promise((resolve) => {
      return Services
        .get(`api/contracts/contract/${contractId}/details/${detailId}/fees`)
        .then( ({data}) => {      
          if (data && data.success && Array.isArray(data.fees)) {
            return resolve(data.fees);  
          }
          return resolve([]);
        })
        .catch(() => {
          return resolve([]);
        }); 
    })
  },
  getContractPayment( contractId ) {
    return new Promise((resolve) => {
      return Services
        .get(`api/contracts/contract/${contractId}/payment`)
        .then( ({data}) => {      
          if (data && data.success) {
            return resolve({
              success: true
            });  
          }

          return resolve({
            success: false,
            error: data.error
          });
        })
        .catch(() => {
          return resolve({
            success: false
          });
        }); 
    })
  }  

}